import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#FAF7F2] text-slate-400 py-20 border-t border-[#F2ECE4]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start mb-16 space-y-12 md:space-y-0">
          <div className="max-w-xs">
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-pink-100 rounded-xl flex items-center justify-center font-black text-pink-300 text-xl shadow-sm border border-pink-50">T</div>
              <span className="text-2xl font-black text-slate-700 tracking-tighter">TOEFL 30 JUMP</span>
            </div>
            <p className="text-sm leading-relaxed text-slate-400 font-medium">
              단 30회, TOEFL 공식 자료와 고지능 AI 코칭 시스템으로 당신의 영어 실력을 대학 수준까지 확실하게 끌어올립니다.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-16">
            <div>
              <h5 className="text-slate-700 font-bold mb-6 text-sm uppercase tracking-widest">Legal</h5>
              <ul className="space-y-4 text-sm font-medium">
                <li><a href="#/privacy-policy" className="hover:text-pink-300 transition-colors">개인정보처리방침</a></li>
                <li><a href="#/terms-of-use" className="hover:text-pink-300 transition-colors">서비스 이용 약관</a></li>
              </ul>
            </div>
            <div>
              <h5 className="text-slate-700 font-bold mb-6 text-sm uppercase tracking-widest">Support</h5>
              <ul className="space-y-4 text-sm font-medium">
                <li className="flex flex-col">
                  <span className="text-slate-300 text-[10px] font-bold uppercase mb-1">Email</span>
                  <a href="mailto:sumingim707@gmail.com" className="text-slate-500 hover:text-pink-400 transition-colors">sumingim707@gmail.com</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[#F2ECE4] flex flex-col md:flex-row justify-between items-center text-[11px] font-bold text-slate-300 tracking-wider">
          <p>© 2026 TOEFL 30 JUMP. ALL RIGHTS RESERVED.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 opacity-80 uppercase">
            <span>주식회사 에이아이잉글리시</span>
            <span className="hidden md:inline text-pink-50">|</span>
            <span>대표이사: 김도약</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;